import {newStepValue, startStep} from "../../../../../services/flowBuilder/utils/constants";
import {EditPermissions} from "../../../../../../../shared/models";
import {Form, FormArray, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {getEditTypes} from "../../../delegatorUtils";
import {dateValidator, isNumber, required, urlValidator} from "../../../../../../../shared/utils";

export class ContactSendingFormNode {
    menu: any = {};

    constructor(nodeType: string) {
        this.menu = {
            'menuType': nodeType,
        };
    }

    static toForm(stepData: { [index: string]: any }) {
        return {
            menuParams: this.menuParamsForm(stepData)
        };
    }

    static menuParamsForm(stepData) {
        const menu = stepData?.menu;
        return {
            contact: {
                name: {
                    firstName: menu?.menuParams?.contact?.name?.firstName ? menu.menuParams.contact.name.firstName : '',
                    lastName: menu?.menuParams?.contact?.name?.lastName ? menu.menuParams.contact.name.lastName : '',
                    formattedName: menu?.menuParams?.contact?.name?.formattedName ? menu.menuParams.contact.name.formattedName : '',
                },
                addresses: this.fromObjToArray(menu?.menuParams?.contact?.addresses),
                org: menu?.menuParams?.contact?.org ? [menu?.menuParams?.contact?.org] : [],
                emails: this.fromObjToArray(menu?.menuParams?.contact?.emails),
                urls: this.fromObjToArray(menu?.menuParams?.contact?.urls),
                birthdays: menu?.menuParams?.contact?.birthday ? [{birthday: menu?.menuParams?.contact?.birthday}] : [],
                phones: this.fromObjToArray(menu?.menuParams?.contact?.phones),
            },
            addNewField: menu?.menuParams?.addNewField ? menu.menuParams.addNewField: '',
            direction: 'outbound',
            next: stepData?.next ? stepData.next : newStepValue
        }
    }

    static fromObjToArray(contact: {}) {
        const contactArray = [];
        if (contact) {
            for (const key in contact) {
                contactArray.push(contact[key])
            }
        }

        return contactArray;
    }

    static getMenuTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            firstName: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('first name')]),
            lastName: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('last name')]),
            formattedName: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('formatted name')]),
            addNewField: new UntypedFormControl({
                value: false,
                disabled: !editFlows
            }, []),
            next: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            })
        })
    }

    static getAddressTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            type: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('address type')]),
            street: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('street')]),
            city: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('city')]),
            state: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('state')]),
            zip: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('zip')]),
            country: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('country')])
        })
    }

    static getEmailTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            type: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('email type')]),
            email: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('email value'), Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])
        })
    }

    static getOrganisationTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            title: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('title')]),
            department: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('department')]),
            company: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('company name')])
        })
    }

    static phoneNumberValidator(control: UntypedFormControl): { [key: string]: any } | null {
        const phoneNumberPattern = /^(\+\d{1,3}\s?)?\d{1,}(\s?\d{1,})*$/;
        const value = control.value;

        if (value && !phoneNumberPattern.test(value)) {
            return { invalidPhoneNumber: true };
        }
        return null;
    }

    static getPhoneTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            type: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('number type')]),
            phone: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('phone number'),this.phoneNumberValidator]),
            waId: new UntypedFormControl({
                value: false,
                disabled: !editFlows
            })
        })
    }



    static getUrlTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            type: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[required('url type')]),
            url: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [urlValidator()])
        })
    }

    static getBirthdayTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            birthday: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            },[dateValidator('birthday')])
        })
    }

    addMenuParams(params): void {
        // menuParams.org[0]?.title, menuParams.org[0]?.department, menuParams.org[0]?.company, menuParams.birthdays[0]?.birthday
        const org = params.org[0] ? params.org[0] : undefined;
        // TODO
        // Not sure what the engine wants if birthday was not added
        const birthday = params.birthdays[0]?.birthday;
        const {firstName, lastName, formattedName, addNewField, addresses, emails, phones, urls} = params;
        const formatObjectKeys = (obj) => {
            const formattedObj = {};
            Object.entries(obj).forEach(([key, value]) => {
                formattedObj[key.toString()] = value;
            });
            return formattedObj;
        };
        const menuParams = this.menu.menuParams ? this.menu.menuParams : {};
        this.menu = {
            ...this.menu,
            menuParams: {
                ...menuParams,
                // addNewField,
                direction: 'outbound',
                contact: {
                  name: {
                      firstName,
                      lastName,
                      formattedName,
                  },
                    addresses: formatObjectKeys(addresses),
                    emails: formatObjectKeys(emails),
                    org,
                    phones: formatObjectKeys(phones),
                    urls: formatObjectKeys(urls),
                    birthday
                },
            }
        }
    }

    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            'next': newStepValue,
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }
}
